import { Component, OnInit, ViewChild } from "@angular/core";
import { User } from "src/classes/Automation/UserApp";
import { Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { HostListener } from "@angular/core"; // to navigate by screen size
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { HttpServiceAccount } from "src/app/services/Authorization/http/http.service_Account";
import { NGXLogger } from "ngx-logger";
import { catchError } from "rxjs/operators";
import { PersonIncoming, Person, MainBar, TopBar, BusinessRole } from "src/classes/Authorization/BusinessRole";
import { DynamicDialogService } from "../services/Customer/dynamic-dialog/dynamic-dialog.service";
import { OnlineCounterService } from "../services/online-counter";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.css"],
    providers: [HttpService1, HttpServiceAccount],
})
export class HomeComponent implements OnInit {
    public user: User = new User();
    receiveduser: User = new User();

    // public person: Person = new Person(); ???
    // public receivedperson: Person = new Person(); ???
    public personincoming: PersonIncoming = new PersonIncoming();
    public receivedbusinessrole: BusinessRole = new BusinessRole();

    mainbar: MainBar[];
    topbar: TopBar[];

    @ViewChild("email", { static: false }) email: any;
    @ViewChild("password", { static: false }) password: any;

    pattern: any;
    previousEmail: string;
    isEmailValid: boolean = true;

    previousPassword: string;

    isInvalidCredentialsErrorVisible: boolean = false;
    hasErrorOccured: boolean = false;

    done: boolean = false;
    isTokenExpired: boolean = false;

    constructor(
        private router: Router,
        private logger: NGXLogger,
        private httpServiceAccount: HttpServiceAccount,
        private dynamicDialogService: DynamicDialogService,
        private onlineCounterService: OnlineCounterService,
    ) {
        this.isTokenExpired = this.router.getCurrentNavigation().extras.state ? this.router.getCurrentNavigation().extras.state.tokenExpired : false;
        console.log(this.isTokenExpired);
    }

    ngOnInit(): void {
        // Online counter (every time a user navigates to the login page, the user with that socketId should be removed from the counter)
        this.onlineCounterService.disconnect();
        this.dynamicDialogService.closeDialog();
    }

    goMainSms(): void {
        this.pattern = /^(?!.*\.\.)([a-zA-Z0-9_%+\-]+(?:\.[a-zA-Z0-9_%+\-]+)*)@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,}$/i;

        this.previousEmail = this.email.value;
        this.previousPassword = this.password.value;

        this.isEmailValid = this.pattern.test(this.previousEmail);
        this.isInvalidCredentialsErrorVisible = false;
        this.hasErrorOccured = false;

        if (this.isEmailValid) {
            this.user.useremail = this.previousEmail;
            this.user.userpassword = this.previousPassword;

            this.personincoming = {
                login: this.user.useremail,
                password: this.user.userpassword,
            };

            sessionStorage.setItem("email", this.user.useremail);
            sessionStorage.setItem("password", this.user.userpassword);

            this.logger.info("Connected client of user with email: " + sessionStorage.getItem("email"));

            this.LoginBeautech();
            this.isTokenExpired = false;
        }
    }

    //BeautechWebAPI
    LoginBeautech(): void {
        this.httpServiceAccount
            .postDataLoginBeautech(this.personincoming)
            .pipe(catchError(this.handleError.bind(this)))
            .subscribe(
                (res: User) => {
                    this.receiveduser = res;
                    this.receiveduser.useremail = res.useremail;
                    this.receiveduser.token = res.token;

                    sessionStorage.setItem("token", res.token);
                    sessionStorage.setItem("userFullName", res.fullname);
                    sessionStorage.setItem("businessUserName", res.username);
                    sessionStorage.setItem("businessName", res.businessname);

                    // Online counter (when a user has logged in, the application must add the user to counter)
                    this.onlineCounterService.connect(res.username, this.personincoming.login, this.personincoming.password);

                    //+console.log({ token: res.token }, new Date().toTimeString());
                    console.log({ token: res.token, businessname: res.businessname }, new Date().toTimeString());

                    this.GetBusinessRole();
                    this.GetMainBar();
                },
                (error) => console.log(error),
            );
    }

    handleError(errorResponse: HttpErrorResponse): void {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error("Client Side Error: ", errorResponse.error.message);
            this.logger.error("Client Side Error: ", errorResponse.error.message);
        } else {
            console.error("Server Side Error: " + errorResponse.error.errorText + " Error Code: " + errorResponse.status);
            this.logger.error("Server Side Error: " + errorResponse.error.errorText + " Error Code: " + errorResponse.status);
        }

        if (errorResponse.status === 400) {
            this.isInvalidCredentialsErrorVisible = true;
        } else {
            this.hasErrorOccured = true;
        }
    }

    GetBusinessRole(): void {
        this.httpServiceAccount.getLoggedInUser().subscribe(
            (data: BusinessRole) => {
                this.receivedbusinessrole = data;
                console.log("Business: " + this.receivedbusinessrole.business + " Role: " + this.receivedbusinessrole.role);
                sessionStorage.setItem("userRole", this.receivedbusinessrole.role);
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            },
        );
    }

    GetMainBar(): void {
        this.httpServiceAccount.getMainBar().subscribe(
            (data: MainBar[]) => {
                this.mainbar = data;
                let activeModule = this.mainbar.find((element) => element.mb_active == 2);

                if (!activeModule) {
                    return;
                }

                this.router.navigate(["module" + activeModule.mb_id]);
            },
            (error) => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            },
        );
    }
}
